// Convert object to support use key multiple level
export const getValueMultipleLevel = (obj, path) => [obj].concat(path.split('.')).reduce((a, b) => a[b] ? a[b] : { [b]: null });

// Convert object, array to support use key multiple level
export const getObjectMultipleLevel = (obj) => {
    var root = {};
    (function tree(obj, index) {
        var suffix = toString.call(obj) === "[object Array]" ? "]" : "";
        for (var key in obj) {
            if (!obj.hasOwnProperty(key)) continue;
            root[index + key + suffix] = obj[key];
            if (toString.call(obj[key]) === "[object Array]") tree(obj[key], index + key + suffix + "[");
            if (toString.call(obj[key]) === "[object Object]") tree(obj[key], index + key + suffix + ".");
        }
    })(obj, "");
    return root;
};

export const jsonToFormData = (jsonObject) => {
    const formData = new FormData();

    Object.keys(jsonObject).forEach(key => {
        const value = jsonObject[key];

        if (value !== null && value !== undefined) {
            if (typeof value === 'object' && !(value instanceof File) && !(value instanceof Blob)) {
                // For nested objects, stringify them
                formData.append(key, JSON.stringify(value));
            } else {
                formData.append(key, value);
            }
        }
    });

    return formData;
}